import { initContextualSearch } from 'features/search/ContextualSearch';

function initContextualSearchBar () {

	initContextualSearch('#contextualSearchBarForSort', '#contextualSearchBarBtn');

}

export default initContextualSearchBar;
